import axios from 'axios';
import { parseGrpcStatus } from './grpcStatus';
import { REST_ERROR_KIND, RestError } from './RestError';

// Chỉ đọc được trên browser khi server khai header này trong Access-Control-Expose-Headers,
// không khai thì trả null và nơi gọi phải hiển thị thông báo không kèm số giây.
const readRetryAfterSec = (headers) => {
  const raw = headers?.['retry-after'] ?? headers?.['x-ratelimit-reset'];
  const value = Number.parseInt(raw, 10);
  return Number.isFinite(value) ? value : null;
};

const toRestError = (error) => {
  if (axios.isCancel(error) || error?.code === axios.AxiosError.ERR_CANCELED) {
    return new RestError({ kind: REST_ERROR_KIND.ABORTED, cause: error });
  }
  if (error?.code === axios.AxiosError.ECONNABORTED || error?.code === axios.AxiosError.ETIMEDOUT) {
    return new RestError({ kind: REST_ERROR_KIND.TIMEOUT, cause: error });
  }
  if (error?.response) {
    const { status, data, headers } = error.response;
    const { grpcCode, message, details } = parseGrpcStatus(data);
    return new RestError({
      kind: REST_ERROR_KIND.HTTP,
      message: message || `HTTP ${status}`,
      status,
      grpcCode,
      details,
      retryAfterSec: status === 429 ? readRetryAfterSec(headers) : null,
      cause: error,
    });
  }
  return new RestError({ kind: REST_ERROR_KIND.NETWORK, message: error?.message, cause: error });
};

// Trả về instance axios nguyên bản (get/post/... như thường), chỉ khác ở chỗ mọi lỗi ném ra
// đều đã chuẩn hoá thành RestError nên nơi gọi không phải đụng tới AxiosError.
//
// Core KHÔNG tự đọc process.env và KHÔNG biết token nằm ở đâu: baseURL do app truyền vào (CRA dùng
// REACT_APP_*, Next.js dùng NEXT_PUBLIC_*), token thì app tự lấy từ nguồn auth của mình qua getHeaders.
export const createRestClient = ({ baseURL, timeout = 15000, getHeaders, headers } = {}) => {
  const instance = axios.create({
    baseURL,
    timeout,
    headers: { Accept: 'application/json', ...headers },
  });

  if (getHeaders) {
    instance.interceptors.request.use(async (config) => {
      Object.entries((await getHeaders()) || {}).forEach(([key, value]) => {
        config.headers.set(key, value);
      });
      return config;
    });
  }

  instance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(toRestError(error))
  );

  return instance;
};
